// extracted by mini-css-extract-plugin
export default {"wrapper":"groupBtn_wrapper__iI-Qv","btn":"groupBtn_btn__sy1xw","title":"groupBtn_title__QK4tQ","modal":"groupBtn_modal__+Usy7","modal__content":"groupBtn_modal__content__h-4GC"};